import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './components/Toast';
import CreateEventPage from './pages/CreateEventPage';
import ViewEventPage from './pages/ViewEventPage';
import EventsListPage from './pages/EventsListPage';
import AcceptInvitePage from './pages/AcceptInvitePage';
import NotFoundPage from './pages/NotFoundPage';
import HomePage from './pages/HomePage';
import DebugPage from './pages/DebugPage';
import OrgSettingsPage from './pages/OrgSettingsPage';
import CreateTournamentPage from './pages/CreateTournamentPage';
import TournamentPage from './pages/TournamentPage';
import PublicTournamentPage from './pages/PublicTournamentPage';
import FeedbackWidget from './components/FeedbackWidget';

function App() {
  const [startRoute, setStartRoute] = useState(null);
  const [inviteToken, setInviteToken] = useState(null);

  useEffect(() => {
    // Инициализация Telegram Web App
    if (window.Telegram?.WebApp) {
      const tg = window.Telegram.WebApp;
      tg.ready();
      tg.expand();

      // Применяем цвет фона из темы Telegram
      if (tg.themeParams?.bg_color) {
        document.body.style.backgroundColor = tg.themeParams.bg_color;
      }

      // Отключаем нативное закрытие свайпом на страницах с формами
      if (tg.disableClosingConfirmation) {
        tg.disableClosingConfirmation();
      }

      // Синхронизация пользователя с БД происходит автоматически в каждом API-запросе
      // через findByTelegramUserIdAndUpdateOrCreate, поэтому отдельный вызов /api/users/me здесь не нужен.

      // Парсим start_param
      const startParam = tg.initDataUnsafe?.start_param;
      if (startParam) {
        console.log('Start param:', startParam);

        if (startParam === 'inline_create') {
          setStartRoute('/events/create?mode=inline');
        } else if (startParam.startsWith('event_')) {
          const eventId = startParam.replace('event_', '');
          setStartRoute(`/events/${eventId}`);
        } else if (startParam.startsWith('invite_')) {
          const token = startParam.replace('invite_', '');
          setInviteToken(token);
          setStartRoute('/invite');
        } else if (startParam === 'create' || startParam.startsWith('create_')) {
          // create — открываем форму создания (create_<chatId> — устаревший формат)
          setStartRoute('/events/create');
        } else {
          // Неизвестный start_param — идём на создание по умолчанию
          setStartRoute('/events/create');
        }
      }
    }
  }, []);

  // Показываем загрузку пока парсим start_param
  if (startRoute === null && window.Telegram?.WebApp?.initDataUnsafe?.start_param) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f8fafc',
      }}>
        <div style={{ color: '#6b7280', fontSize: 15 }}>Загрузка...</div>
      </div>
    );
  }

  return (
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          {/* Публичный просмотр турнира — без Telegram, без initData */}
          <Route path="/public/tournaments/:token" element={<PublicTournamentPage />} />

          {/* Если есть start_param — редиректим с главной */}
          <Route
            path="/"
            element={
              startRoute
                ? <Navigate to={startRoute} replace />           // есть start_param — deep link
                : window.Telegram?.WebApp
                  ? <Navigate to="/events" replace />             // Telegram есть, но без start_param — сразу список
                  : <HomePage />                                  // обычный браузер
            }
          />
          {/* Принятие приглашения */}
          <Route
            path="/invite"
            element={inviteToken ? <AcceptInvitePage token={inviteToken} /> : <NotFoundPage />}
          />

          {/* Список всех событий */}
          <Route path="/events" element={<EventsListPage />} />

          {/* Настройки организации */}
          <Route path="/settings" element={<OrgSettingsPage />} />

          {/* Создание турнира */}
          <Route path="/tournaments/new" element={<CreateTournamentPage />} />

          {/* Страница турнира */}
          <Route path="/tournaments/:publicId" element={<TournamentPage />} />

          {/* Создание события */}
          <Route path="/events/create" element={<CreateEventPage />} />

          {/* Просмотр / редактирование события */}
          <Route path="/events/:eventId" element={<ViewEventPage />} />

          {/* Debug */}
          <Route path="/debug" element={<DebugPage />} />

          {/* Всё остальное */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>

        {/* Глобальный виджет обратной связи (скрыт на /public/*) */}
        <FeedbackWidget />
      </BrowserRouter>
    </ToastProvider>
  );
}

export default App;